import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import { Group } from '../models/group';
import { GroupService } from './group.service';
import { Ec2Service } from './ec2.service';

@Injectable()
export class GroupSelectedService {

    private _selected: BehaviorSubject<Group> = new BehaviorSubject(new Group());
    public selected$ = this._selected.asObservable().pipe(filter(group => !!group));

    constructor(private GroupService: GroupService, private ec2Service : Ec2Service){}

    selectAll(): void {
        this._selected.next(new Group());
    }

    select(group:Group) {
        // load the group detailed data (included chains)
        this.GroupService.getById(group.group).subscribe(group => {
            this._selected.next(group)
        })

    }
}